import { Check } from 'lucide-react'
import { TOUR_DEFINITIONS } from './tourRegistry'
import { isTourComplete } from './tourStorage'
import type { TourId } from './tourIds'
import './TourMenu.css'

interface TourMenuProps {
  onStartTour: (tourId: TourId) => void
}

export default function TourMenu({ onStartTour }: TourMenuProps) {
  return (
    <section className="tour-menu" aria-label="Guided tours">
      <h4 className="tour-menu-title">Guided tours</h4>
      <p className="tour-menu-intro">
        Spotlight walkthroughs highlight menus and controls on each page. Completed tours show a checkmark.
      </p>
      <ul className="tour-menu-list">
        {TOUR_DEFINITIONS.map((tour) => (
          <li key={tour.id}>
            <button
              type="button"
              className="tour-menu-item"
              onClick={() => onStartTour(tour.id)}
              aria-label={`Start tour: ${tour.title}`}
            >
              <span className="tour-menu-item-text">
                <span className="tour-menu-item-title">{tour.title}</span>
                <span className="tour-menu-item-desc">{tour.description}</span>
              </span>
              {isTourComplete(tour.id) && (
                <Check size={18} className="tour-menu-complete" aria-label="Completed" />
              )}
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}
